<template>
    <div class="time_select">
        <el-date-picker
            v-model="time"
            type="daterange"
            placeholder=""
            :picker-options="pickerOptions"
            :clearable="false"
            @change="handleDatePicker"
            ref="dataPick"
            :editable="false"
            range-separator="至"
            format="yyyy 年 MM 月 dd 日"
            @click.native="handleNoDisable" />
        <template v-if="showLabel">
            <span class="time_fast_check">
                <span @click="getTimeText($event)" :class="{active:judgeIsActve(2)}">
                    前天
                </span>
                <span @click="getTimeText($event)" :class="{active:judgeIsActve(7)}">
                    近7天
                </span>
                <span @click="getTimeText($event)" :class="{active:judgeIsActve(30)}">
                    近30天
                </span>
            </span>
        </template>
        <span class="tip">
            <el-tooltip effect="dark" content="提示: 昨日数据需延迟一天" placement="top">
                <i class="el-icon-question" />
            </el-tooltip>
        </span>
        <span class="info_text">
            为了更好的体验，数据查询时段限制在3个月内
        </span>
    </div>
</template>

<script>
const OneDayMS = 3600 * 1000 * 24;
const defaultLimitDayNum = Math.floor((new Date() - new Date('2015-01-01')) / OneDayMS);
export default {
    name: "TimeSelect",
    props: {
        timeValue: {
            type: Array,
            default() {
                return [];
            }
        },
        showLabel: {
            type: Boolean,
            default: true
        },
        defaultTime: {
            type: Array,
            default() {
                return [];
            }
        },
        noLimitDayNum: {
            type: Boolean,
            default: false
        },
        limitDayNum: {
            type: Number,
            default() {
                if (this.noLimitDayNum) {
                    return defaultLimitDayNum;
                }
                return 94;
            }
        }
    },
    data() {
        return {
            time: [],
            firstChange: true,
            pick: {
                time: "",
                day: this.limitDayNum
            }
        };
    },
    watch: {
        time() {
            this.getRightDate(this.time);
        },
        limitDayNum() {
            this.pick.time = "";
            this.pick.day = this.limitDayNum;
            let isRightTime = this.isRightDateArr(this.time);
            if (!isRightTime) {
                this.$message({
                    type: 'warning',
                    duration: 1000,
                    message: `时间间隔超出最大${this.limitDayNum + 1}天,自动修改`
                });
                this.time = this.gainTime(this.limitDayNum, this.time[1]);
                this.timeValue.splice(0, this.timeValue.length);
                this.timeValue.push(this.time[0], this.time[1]);
            }
            this.$emit("change", this.time);
        }
    },
    computed: {
        pickerOptionsBase() {
            let _this = this;
            let shortcuts = [{
                text: "近三个月",
                onClick(picker) {
                    _this.pick.time = "";
                    const end = new Date(new Date() - OneDayMS * 1);
                    const start = new Date(new Date() - OneDayMS * 90);
                    picker.$emit("pick", [start, end]);
                }
            }];
            if (this.limitDayNum >= 364) {
                shortcuts.push({
                    text: "近一年",
                    onClick(picker) {
                        _this.pick.time = "";
                        const end = new Date(new Date() - OneDayMS * 1);
                        const start = new Date(new Date() - OneDayMS * 365);
                        picker.$emit("pick", [start, end]);
                    }
                });
                let maxYear = new Date().getFullYear();
                for (let i = maxYear; i >= 2015; i--) {
                    let maxEnd;
                    if (i == maxYear) {
                        maxEnd = new Date(new Date() - OneDayMS * 1);
                    }
                    let obj = {
                        text: i + "年",
                        onClick(picker) {
                            _this.pick.time = "";
                            let endTimeStr = `${i}-12-31`;
                            let startTimeStr = `${i}-01-01`;
                            let end;
                            if (maxEnd) {
                                end = maxEnd;
                            } else {
                                end = new Date(endTimeStr);
                            }
                            const start = new Date(startTimeStr);
                            picker.$emit("pick", [start, end]);
                        }
                    };
                    shortcuts.push(obj);
                }
            }
            return {
                shortcuts: shortcuts
            };
        },
        pickerOptionsDisabled() {
            let _this = this;
            return {
                disabledDate(time) {
                    if (_this.pick.day >= defaultLimitDayNum) {
                        const end = new Date(new Date() - OneDayMS);
                        end.setTime(
                            end.getTime() - 3600 * 1000 * 24 * _this.pick.day
                        );
                        return (
                            time.getTime() > Date.now() - OneDayMS || time.getTime() < end
                        );
                    }
                    if (!_this.time[0]) {
                        const end = new Date("2014-12-31");
                        return (
                            time.getTime() > Date.now() - OneDayMS || time.getTime() < end
                        );
                    } else {
                        let tempTime = "";
                        if (!_this.pick.time) {
                            tempTime = _this.time[0];
                        } else {
                            tempTime = _this.pick.time;
                        }
                        let endTime = new Date(tempTime);
                        let startTime = new Date(tempTime);
                        startTime.setTime(
                            startTime.getTime() - 3600 * 1000 * 24 * _this.limitDayNum
                        );
                        endTime.setTime(
                            endTime.getTime() + 3600 * 1000 * 24 * _this.limitDayNum
                        );
                        if (endTime > Date.now() - OneDayMS) {
                            endTime = Date.now() - OneDayMS;
                        }
                        if (startTime < new Date("2015-01-01")) {
                            startTime = new Date("2015-01-01");
                        }
                        return (
                            time.getTime() > endTime ||
                            time.getTime() < startTime
                        );
                    }
                },
                onPick(obj) {
                    _this.pick.time = new Date(obj.minDate);
                    _this.pick.day = _this.limitDayNum;
                    _this.$refs.dataPick.pickerOptions.disabledDate(
                        new Date(obj.minDate)
                    );
                }
            };
        },
        pickerOptions() {
            return Object.assign({},
                this.pickerOptionsDisabled,
                this.pickerOptionsBase
            );
        }
    },
    methods: {
        formatDate(time) {
            let year = new Date(time).getFullYear();
            let month = new Date(time).getMonth() + 1;
            let date = new Date(time).getDate();
            month = month.toString().padStart(2, 0);
            date = date.toString().padStart(2, 0);
            return year ? year + "-" + month + "-" + date : "";
        },
        gainTime(dayNum, startTime) {
            let end, start;
            if (startTime) {
                end = new Date(startTime);
                start = new Date(startTime);
            } else {
                end = new Date();
                start = new Date();
            }
            start.setTime(start.getTime() - 3600 * 1000 * 24 * dayNum);
            if (dayNum === 1) {
                end = start;
            }
            end = this.formatDate(end);
            start = this.formatDate(start);
            let arr = [start, end];
            return arr;
        },
        handleNoDisable() {
            this.pick.time = "";
            this.pick.day = defaultLimitDayNum;
        },
        handleDatePicker() {
            this.timeChange();
        },
        // 格式化时间数组
        getRightDate(date) {
            for (let i in date) {
                date[i] = this.formatDate(date[i]);
            }
        },
        judgeIsActve(dayNum) {
            let end = new Date(new Date() - OneDayMS);
            const start = new Date();
            if (dayNum == 2) {
                end = start;
            }
            start.setTime(start.getTime() - OneDayMS * dayNum);
            let startTime = this.formatDate(start);
            end = this.formatDate(end);
            if (this.time && this.time.length) {
                if (this.formatDate(this.time[0]) == startTime && this.formatDate(this.time[1]) == end) {
                    return true;
                }
            }
            return false;
        },
        // 快速时间选择
        getTimeText(event) {
            let labelText = event.target.innerHTML;
            if (labelText == "最近一次") {
                this.time = [];
                this.isRecently = true;
            } else {
                this.isRecently = false;
                this.time = this.timeFastCheck(labelText);
                this.timeChange();
            }
        },
        // 点击文字快速选择
        timeFastCheck(labelText) {
            let dayNum;
            let end = new Date(new Date() - OneDayMS);
            const start = new Date();
            switch (labelText.trim()) {
                case "前天":
                    dayNum = 2;
                    end = start;
                    break;
                case "近7天":
                    dayNum = 7;
                    break;
                case "近30天":
                    dayNum = 30;
                    break;
            }
            let arr = [];
            start.setTime(start.getTime() - OneDayMS * dayNum);
            let startTime = this.formatDate(start);
            end = this.formatDate(end);
            arr = [startTime, end];
            return arr;
        },
        // 设置默认值
        setDefaultValue() {
            if (!this.defaultTime) {
                this.time = this.timeFastCheck("近7天");
            } else {
                this.time = this.defaultTime;
            }
        },
        isRightDateArr(arr) {
            if (arr.length != 2) {
                return false;
            }
            const end = new Date() - OneDayMS;
            let startTime = new Date(arr[0]);
            let endTime = new Date(arr[1]);
            if (startTime == "Invalid Date" || endTime == "Invalid Date") {
                return false;
            }
            if (endTime > end) {
                return false;
            }
            if (startTime > endTime || startTime < new Date("2015-01-01")) {
                return false;
            }
            let days = (endTime - startTime) / OneDayMS;
            if (days > this.limitDayNum) {
                return false;
            }
            return true;
        },
        // 筛选
        timeChange() {
            this.getRightDate(this.time);
            this.timeValue.splice(0, this.timeValue.length);
            this.timeValue.push(this.time[0], this.time[1]);
            if (!this.firstChange) {
                this.$emit("change", this.time);
            }
            this.firstChange = false;
        }
    },
    mounted () {
        this.setDefaultValue();
        this.timeChange();
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.time_select {
    display: inline-block;
}
.time_fast_check {
    margin-left: 10px;
}
.time_fast_check span {
    display: inline-block;
    padding-right: 5px;
    padding-left: 5px;
    font-size: 14px;
    color: #00b7ef;
    border-radius: 5px;
    cursor: pointer;
    margin-right: 5px;
    border: 1px solid #00b7ef;
}
.time_fast_check span.active {
    color: red;
    border-color: red;
}
.time_fast_check span.disabled {
    color: red;
    border-color: red;
}
.time_select .tip {
    font-size: 20px;
    vertical-align: middle;
    color: #ff913b;
}
.time_select .info_text {
    font-size: 14px;
    display: inline-block;
    color: #a5a4a5;
}
.time_select .el-date-editor .el-range__close-icon {
    display: none;
}
.time_select .el-date-editor .el-range-input {
    width: 50%;
}
.time_select .el-range-editor {
    width: 315px !important;
}
</style>
